<div class="login-form col-12 col-sm-8 col-md-6 col-lg-6 offset-sm-1 offset-md-1 offset-lg-2">
  <div>
    <button
      role="button"
      type="button"
      aria-label="Go Back"
      class="btn btn-link"
      (click)="go2PrevRoute()"
    >
      <i class="fa fa-backward" aria-hidden="true" style="font-size: 0.75em"></i>
      <u style="font-size: 0.75em">Go back</u>
    </button>

    @if (showRegisterInfo && !showLoginInfo) {
      <!-- 05-04-2020:- 62315 - Zinio Sign up screen has no title or explanation (confusing) - changes by Paul M -->
      @if (targetType === TARGETTYPE.ZN) {
        <div class="margin-30 font-weight-bold">
          Please enter the information below for access to Zinio. You'll only need to add it once in
          VERSO and once when you download your first magazine - after that your login will be
          remembered
        </div>
      }
    }

    @if (!showRegisterInfo && showLoginInfo) {
      <!-- 05-04-2020:- 62315 - Zinio Sign up screen has no title or explanation (confusing) - changes by Paul M -->
      @if (targetType === TARGETTYPE.ZN) {
        <div class="margin-30 font-weight-bold">
          Please enter the information below for access to Zinio using your existing Zinio acccount.
        </div>
      }
    }
  </div>

  @if (!showRegisterInfo && showLoginInfo) {
    @if (targetType === TARGETTYPE.ZN) {
      <div class="card" style="margin-top: 10vh; margin-bottom: 10vh">
        @if (showZNForm) {
          <div class="card-block">
            <form
              class="form-horizontal loginform"
              autocomplete="off"
              [formGroup]="loginZN"
              novalidate
            >
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="email"
                  matInput
                  formControlName="email"
                  [placeholder]="emailLabel"
                  [attr.title]="emailLabel"
                />
              </mat-form-field>
              @if (loginZN.get('email').errors?.pattern) {
                <small class="text-danger padding-5-0">Please provide a valid email address.</small>
              }
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="password"
                  matInput
                  formControlName="password"
                  autocomplete="new-password2"
                  [placeholder]="passwordLabel"
                  [attr.title]="passwordLabel"
                />
              </mat-form-field>
              @if (loginZN.get('password').errors?.minlength) {
                <small class="text-danger padding-5-0"
                  >Password should at least have 3 characters long.</small
                >
              }
              <!-- Submit and Clear -->
              <div class="text-end clearfix">
                <button
                  role="button"
                  type="button"
                  aria-label="Submit"
                  class="btn btn-primary"
                  [disabled]="!loginZN.valid"
                  (click)="loginZNSubmit()"
                  (keyup.enter)="loginZNSubmit()"
                >
                  <span style="width: 175px">Submit</span>
                </button>
                <button
                  role="button"
                  aria-label="Clear"
                  type="button"
                  class="btn btn-link margin-0-10"
                  (click)="loginZN.reset()"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    }
  }

  @if (showRegisterInfo && !showLoginInfo) {
    @if (targetType === TARGETTYPE.RB) {
      <div class="card" style="margin-top: 10vh; margin-bottom: 10vh">
        @if (showRBForm) {
          <div class="card-block">
            <!-- https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion -->
            <form
              #registerRBform
              class="form-horizontal registerform"
              autocomplete="off"
              [formGroup]="registerRB"
              novalidate
            >
              <!-- Library Card Number -->
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="libname"
                  [placeholder]="libraryLabel"
                  [attr.title]="libraryLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="user"
                  [placeholder]="userNameLabel"
                  [attr.title]="userNameLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <!-- <mat-label>{{passwordLabel}}</mat-label> -->
                <input
                  type="password"
                  matInput
                  formControlName="password"
                  autocomplete="new-password1"
                  [placeholder]="passwordLabel"
                  [attr.title]="passwordLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="firstname"
                  [placeholder]="firstNameLabel"
                  [attr.title]="firstNameLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="lastname"
                  [placeholder]="lastNameLabel"
                  [attr.title]="lastNameLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="email"
                  matInput
                  formControlName="email"
                  [placeholder]="emailLabel"
                  [attr.title]="emailLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="zip"
                  [placeholder]="zipLabel"
                  [attr.title]="zipLabel"
                />
              </mat-form-field>
              <!-- Submit and Clear -->
              <div class="text-end clearfix">
                <button
                  role="button"
                  type="button"
                  aria-label="Submit"
                  class="btn btn-primary"
                  [disabled]="!registerRB.valid"
                  (click)="registerRBSubmit()"
                  (keyup.enter)="registerRBSubmit()"
                >
                  <span style="width: 175px">Submit</span>
                </button>
                <button
                  role="button"
                  aria-label="Clear"
                  type="button"
                  class="btn btn-link margin-0-10"
                  (click)="registerRB.reset()"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        }
      </div>
      <!-- <div class="container-fluid" *ngIf="patronSubmitDetails">
                        <div class="row">
                          <div class="col-12">
                            <p>Library Card Number: {{patronSubmitDetails.libraryCardNumber}}</p>
                            <p>First Name: {{patronSubmitDetails.firstName}}</p>
                            <p>Last Name: {{patronSubmitDetails.lastName}}</p>
                            <p>User Name: {{patronSubmitDetails.userName}}</p>
                            <p>Password: {{patronSubmitDetails.password}}</p>
                            <p>Email Address: {{patronSubmitDetails.email}}</p>
                            <p>Patron Id: {{patronSubmitDetails.patronId}}</p>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="registerSuccess">
                        <button role="button" aria-label="Go to Full Record" class="btn btn-dark" (click)="fullRecord()">Go to FullRecord</button>
                      </div> -->
    }
    @if (targetType === TARGETTYPE.ZN) {
      <div class="card" style="margin-top: 10vh; margin-bottom: 10vh">
        @if (showZNForm) {
          <div class="card-block">
            <!-- https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion -->
            <form
              class="form-horizontal registerform"
              autocomplete="off"
              [formGroup]="registerZN"
              novalidate
            >
              <!-- Library Card Number -->
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="firstname"
                  [placeholder]="firstNameLabel"
                  [attr.title]="firstNameLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="text"
                  matInput
                  formControlName="lastname"
                  [placeholder]="lastNameLabel"
                  [attr.title]="lastNameLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <input
                  type="email"
                  matInput
                  formControlName="email"
                  [placeholder]="emailLabel"
                  [attr.title]="emailLabel"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%" class="clearfix">
                <!-- <mat-label>{{passwordLabel}}</mat-label> -->
                <input
                  type="password"
                  matInput
                  formControlName="password"
                  autocomplete="new-password2"
                  [placeholder]="passwordLabel"
                  [attr.title]="passwordLabel"
                />
              </mat-form-field>
              <!-- Submit and Clear -->
              <div class="text-end clearfix">
                <button
                  role="button"
                  type="button"
                  aria-label="Submit"
                  class="btn btn-primary"
                  [disabled]="!registerZN.valid"
                  (click)="registerZNSubmit()"
                  (keyup.enter)="registerZNSubmit()"
                >
                  <span style="width: 175px">Submit</span>
                </button>
                <button
                  role="button"
                  aria-label="Clear"
                  type="button"
                  class="btn btn-link margin-0-10"
                  (click)="registerZN.reset()"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    }
  }
</div>
